module.exports = __webpack_public_path__ + "img/product_img2_title.48ef8d8f.jpg";